module.exports = __webpack_public_path__ + "img/dcs.ddcb3fc3.png";